import * as XLSX from "xlsx";
import { QueryType, SqlQueryInfo } from "./types";
import { GetSqlQueriesResponse } from "../../services/api/routes/sqlQueries";
import { IdbStorage } from "./db/queriesIdb";

export const downloadXLSX = (
  csvData: string,
  usinaName: string,
  queryName: string
) => {
  const workbook = XLSX.read(csvData, { type: "string" });

  const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });

  const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
  const url = window.URL.createObjectURL(blob);

  const link = document.createElement("a");
  link.href = url;
  link.download = `Consulta ${queryName} - ${usinaName}.xlsx`;
  document.body.appendChild(link);

  link.click();

  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
};

export const copyToClipboard = (text: string) => {
  navigator.clipboard
    .writeText(text)
    .then(() => {})
    .catch((err) => {
      console.error("Failed to copy text: ", err);
    });
};
export const formatElapsedTime = (elapsedTime: string) => {
  const [minutes, seconds, milliseconds] = elapsedTime.split(":");
  return `${minutes}m:${seconds}s:${Number(milliseconds)
    .toFixed(2)
    .padStart(5, "0")}ms`;
};

export const hasTime = (time?: string) => {
  return time && time !== "00:00:00";
};
export const hasData = (query: SqlQueryInfo) => {
  return (
    (query.csvResult && query.csvResult.length > 0) ||
    query.error ||
    hasTime(query.elapsedExecutionTime)
  );
};

export const replaceQueriesById = (
  originalQueries: SqlQueryInfo[],
  parsedQueries: SqlQueryInfo[]
) => {
  return originalQueries.map((query) => {
    const parsedQuery = parsedQueries.find((pq) => pq.id === query.id);
    return parsedQuery ? parsedQuery : query;
  });
};
export const updateQueryType = (
  parsedQueries: GetSqlQueriesResponse,
  queryType: QueryType,
  updatedQuery: SqlQueryInfo
) => {
  const queryIds = parsedQueries[queryType]?.map((query) => query.id) || [];
  if (queryIds.includes(updatedQuery.id)) {
    parsedQueries[queryType] = replaceQueriesById(parsedQueries[queryType], [
      updatedQuery,
    ]);
  } else if (parsedQueries[queryType]) {
    parsedQueries[queryType].push(updatedQuery);
  } else {
    parsedQueries[queryType] = [updatedQuery];
  }
};

export const handleUpdateStorage = async (
  updatedQuery: SqlQueryInfo,
  sqlQueries: GetSqlQueriesResponse,
  idbStorage: IdbStorage,
  dbKey: string
) => {
  const localQueries = await idbStorage.getItem(dbKey);
  if (localQueries) {
    const parsedQueries: GetSqlQueriesResponse = JSON.parse(localQueries);
    if (parsedQueries) {
      updateQueryType(parsedQueries, "dashboardQueries", updatedQuery);
      updateQueryType(parsedQueries, "relatorioDiarioQueries", updatedQuery);
      updateQueryType(parsedQueries, "relatorioMensalQueries", updatedQuery);
      await idbStorage.setItem(dbKey, JSON.stringify(parsedQueries));
    }
  } else {
    const dashboardQueriesIds =
      sqlQueries?.dashboardQueries.map((query) => query.id) || [];
    const relatorioDiarioQueriesIds =
      sqlQueries?.relatorioDiarioQueries.map((query) => query.id) || [];
    const relatorioMensalQueriesIds =
      sqlQueries?.relatorioMensalQueries.map((query) => query.id) || [];
    const newQueries = {
      dashboardQueries: dashboardQueriesIds.includes(updatedQuery.id)
        ? [updatedQuery]
        : [],
      relatorioDiarioQueries: relatorioDiarioQueriesIds.includes(
        updatedQuery.id
      )
        ? [updatedQuery]
        : [],
      relatorioMensalQueries: relatorioMensalQueriesIds.includes(
        updatedQuery.id
      )
        ? [updatedQuery]
        : [],
    };
    await idbStorage.setItem(dbKey, JSON.stringify(newQueries));
  }
};
